import { useTexts } from 'utils/useTexts';
import Footer from '@components/shared/Footer/Footer';
import EnterLicensePlateManuallyForm from '@components/EnterLicensePlateManuallyForm/EnterLicensePlateManuallyForm';

const EnterLicensePlateManually = () => {
  const { t } = useTexts();

  return (
    <>
      <EnterLicensePlateManuallyForm />
      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default EnterLicensePlateManually;
